import InfoActivity from './popover-info-activity-view'
export default InfoActivity
